<template>
  <div>
    <div class="tabs">
      <ul>
        <router-link
          v-for="(item,index) in items[menu]"
          :to="item.value" tag="li" :key="item.value">
          <a>
            {{ item.name }}
          </a>
        </router-link>
        <li v-if="isEditor" class="router-link-exact-active">
          <a>
            <span class="icon"><i class="far fa-file-alt"></i></span>
            <span>Editor</span>
          </a>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>

  import _ from 'lodash';

  export default {
    props: ['menu'],
    methods: {
      onChange: function() {
        this.$router.push(this.selected);
        this.selected = "default";
      }
    },
    computed: {
      isEditor() {
        return _.includes([
          "dashboard_channel_edit",
          "dashboard_seiten_edit",
          "dashboard_module_edit"
        ],
        this.$route.name);
      }
    },
    data: function () {
      return {
        selected: "default",
        items: {
          channel: [
            {
              name: "Übersicht",
              value: "/dashboard/channel/liste"
            },
            {
              name: "Öffentliche Channel",
              value: "/dashboard/katalog?filter=channel"
            }
          ],
          seiten: [
            {
              name: "Übersicht",
              value: "/dashboard/seiten/liste"
            },
            {
              name: "Öffentliche Seiten",
              value: "/dashboard/katalog?filter=seiten"
            }
          ],
          module: [
            {
              name: "Übersicht",
              value: "/dashboard/module/liste"
            },
            {
              name: "Öffentliche Module",
              value: "/dashboard/katalog?filter=module"
            }
          ],
          profile: [
            {
              name: "Details",
              value: "/dashboard/profil/details"
            },
            {
              name: "Player",
              value: "/dashboard/profil/player"
            },
            {
              name: "Tourismus Region",
              value: "/dashboard/profil/organization"
            }
          ]
        }
      }
    },
    mounted() {

    }
  }
</script>

<style scoped>

  .tabs {
    margin-bottom: 0;
  }

  .tabs ul {
    border-bottom-color: rgba(27, 42, 50, 0.10);
  }

  a {
    font-weight: 600;
    color: #64757E;
  }

  a:hover {
    color: var(--ois-ink, #1B2A32);
  }

  /* Active tab — accent underline instead of the old grey folder tab */
  .router-link-exact-active a {
    color: var(--ois-ink, #1B2A32);
    font-weight: 700;
    border-bottom-color: var(--ois-accent, #FF0266);
  }

</style>
